// @flow
import React from 'react';

import {compose} from 'redux';
import {connect} from 'react-redux';
import {evaluationIsVariant} from '@homeaway/react-experiment';
import HitExperimentInfoMobile from './HitExperimentInfoMobile';
import HitExperimentInfoDesktop from './HitExperimentInfoDesktop';
import {media} from '../../../utils/breakpoints';
import {injectIntl} from 'react-intl';
import {listingHasPriceSecondary} from '../../Price/Price';
import {isDateless} from '../../../utils/searchParamsUtils';
import {
    VRBO_OPAS_SECONDARY_PRICE_EU,
    VRBO_SERP_HITS_REDESIGN
} from '../../../abacus/experiments';

import type {IntlShape} from 'react-intl';
import type {ListingShape as DetailsListingShape} from '../../Details/Details';
import type {Shape as GeoDistanceShape} from '../../GeoDistance/GeoDistance';
import type {ListingShape as HitListingShape} from '../../Hit/Hit';

import type {PriceListingShape} from '../../Price/Price';
import type {ListingShape as RatingListingShape} from '../../Rating/Rating';
import type {State as ReduxState} from '../../../reducers/index';
import type {BadgeShape as Badge} from '../../Hit/Hit';
import './HitExperimentInfo.less';

export type ListingShape = DetailsListingShape &
    PriceListingShape &
    RatingListingShape &
    GeoDistanceShape & {
        detailPageUrl: string,
        instantBookable: boolean,
        listingId: string,
        minStayRange: {
            minStayHigh: number,
            minStayLow: number
        },
        amenitiesBadges: ?(Badge[]),
        propertyId: string,
        propertyMetadata: ?{
            headline: string
        },
        rankedBadges: ?(Badge[]),
        superlativesBadges: ?(Badge[]),
        webRatingBadges: ?(Badge[]),
        unitMessage: ?Object,
        unitMetadata: ?{
            unitName: string
        }
    };

type StateProps = {
    brand: string,
    isDatelessSearch: boolean,
    isHovered: boolean,
    isDesktop: boolean,
    isMetric: boolean,
    fullLocale: string,
    showDesktopHits: boolean
};

type IntlProps = {
    intl: IntlShape
};

export type OwnProps = {
    hitIndex?: number,
    isFreeCancellationOff: boolean,
    listing: HitListingShape,
    listingHasSecondaryPrice?: boolean,
    isPriceAccurateAllowed?: boolean,
    isMultiUnitHit?: boolean,
    onClick: () => void
} & IntlProps;

export type Props = OwnProps & StateProps;

export function HitExperimentInfo(props: Props) {
    const {showDesktopHits, ...propsToPass} = props;

    if (showDesktopHits) {
        return <HitExperimentInfoDesktop {...propsToPass} />;
    }
    return <HitExperimentInfoMobile {...propsToPass} />;
}

const mapStateToProps = (
    {
        abacus,
        searchParams: {params},
        map: {listingId: hoveredListingId},
        system: {brand, isDesktop, isMetric, fullLocale, siteFeatures},
        viewport: {breakpoint}
    }: ReduxState,
    {listing}: OwnProps
) => {
    const isHovered = listing.listingId === hoveredListingId && isDesktop;
    const isDatelessSearch = isDateless(params);
    const isPriceAccurateAllowed = evaluationIsVariant(
        abacus[VRBO_OPAS_SECONDARY_PRICE_EU],
        1
    );

    return {
        brand,
        isDatelessSearch,
        isDesktop,
        isHovered,
        isMetric,
        showDesktopHits: media(breakpoint, {
            minWidth: 'SM_MIN'
        }),
        siteFeatures,
        fullLocale,
        listingHasSecondaryPrice: listingHasPriceSecondary(
            listing,
            isPriceAccurateAllowed
        ),
        isPriceAccurateAllowed,
        hitRedesignTestVariant: (abacus[VRBO_SERP_HITS_REDESIGN] || {}).value
    };
};

export default compose(injectIntl, connect(mapStateToProps))(HitExperimentInfo);
